require('vendor/assets/javascripts/flux-dispatchr/BaseStore');
require('vendor/assets/javascripts/flux-dispatchr/Dispatchr.js')
require('searches/search_context')
require('searches/utils/search_observers')
require('searches/utils/fragment_highlighter')
require('searches/utils/welcome_modal')
require('searches/utils/search_results_reposition')
require('searches/stores')
require('searches/components')
require('mobile_helpers')
require('link_opener')
require('boclips/lp_boclips')

import SearchResultsReposition from './searches/utils/search_results_reposition';
import SearchInfiniteScroll from 'js/search_infinite_scroll';
import CollectionBuilder from 'js/collections/builder/init'
import FacetSidebar from 'js/searches/filter/facets/facet_sidebar';
import SelectedFacets from 'js/searches/controls/selected_facets/selected_facets_list';
import SearchSort from 'js/searches/controls/sort/search_sort';
import SearchTabs from 'js/searches/tabs/search_tabs';
import SearchCounts from "js/searches/controls/layout/search_counts"
import posthog from 'posthog-js';
import { PH_EVENTS } from 'js/posthog_analytics';
import HowdyBoxSearch from 'js/searches/howdy_box/howdy_box_search';

Searches    = LP.module 'Searches'
Resources   = LP.module 'Resources'
Analytics   = LP.module 'Analytics'
LpBoclips   = LP.module('LpBoclips')

loadLazyImages = ->
  # PageSpeed - search top banner
  if $("#js-carousel").length
    # mobile devices have a carousel
    $.each $("#js-carousel .cta-carousel"), (i, e) ->
      $(e).addClass("panel-#{i+1}")
  else
    # desktops have the CB banner
    $("#search-cb-banner").addClass('background')

Searches.applyLoaderToResultCards = ->
  return unless $('#boclips-search-page').length > 0 && $('#boclips-search-page').is(':visible')
  $(".resource-card-loader").addClass('loading')
  $('#js-search-heading').addClass('invisible');

Searches.removeLoaderFromResultCards = ->
  $(".resource-card-loader").removeClass('loading')

Searches.initializeTooltip = ->
  $('[data-toggle="tooltip"]').tooltip()

Searches.loadPanels = (context) ->
  context.executeAction(Searches.SearchActions.loadPanels)

Searches.show = ->
  # iPAD
  window.onunload = (e) ->
    window.scrollTo(0, 0)

  # Desktops. Chrome.
  window.onbeforeunload = (e) ->
    window.scrollTo(0, 0)

  $(document).ready ->
    loadLazyImages()

  new CollectionBuilder() if LP.config.logged_in
  @bindCollectionBuilderVimeoVideo()
  @bindStopScrollOnDisabledPaginationButtons()

  if LP.config.withInfiniteScroll
    SearchInfiniteScroll.init()

  @SearchContext.registerStore @ParamStore
  @SearchContext.registerStore @FacetStore
  @SearchContext.registerStore @PanelStore
  @SearchContext.registerStore @RouteStore
  @SearchContext.registerStore @SearchStore
  @SearchContext.registerStore Resources.ResourceStore
  if LpBoclips? && LpBoclips.VideoModeStore? && $('#boclips-videos-section').length == 1
    @SearchContext.registerStore LpBoclips.VideoModeStore
  else if LpBoclips? && LpBoclips.VideoMediaTabStore? && $('#boclips-videos-section').length == 0 && LP.config.search_tabs_enabled == true
    @SearchContext.registerStore LpBoclips.VideoMediaTabStore
  @SearchContext.registerStore Searches.SearchResultsLoader
  if !LP.config.site_license_no_providers_available && LP.config.search_tabs_path
    @SearchContext.registerStore @SearchTabStore
  context = new @SearchContext LP.config
  context.getStore('ParamStore').initialize params: LP.config.search_params
  Resources.ResourceModal.setContext context.componentContext
  if LpBoclips? && LpBoclips.BoclipsModal? &&
    (
      ($('#boclips-videos-section').length == 0 && LP.config.search_tabs_enabled == true) ||
        $('#boclips-videos-section').length == 1
    )
    LpBoclips.BoclipsModal.setContext(context.componentContext)

  @loadPanels(context)

  new @SearchObservers context: context.componentContext
  new @WelcomeModal path: LP.config.modal_path, context: context.componentContext

  @FragmentHighlighter.highlight keywords: context.getStore('ParamStore').get('keywords')
  context.fetcher.createUserSearch params: LP.config.search_params
  @initializeTooltip()

  facetSidebarContainer = document.getElementById('facet-sidebar');
  ReactDOM.createRoot(facetSidebarContainer).render(
    React.createElement(FacetSidebar, context: context.componentContext)
  );

  if LP.config.ai_teachers_tools_howdy_box_enabled
    howdyBoxContainer = document.getElementById('howdy-box');
    ReactDOM.createRoot(howdyBoxContainer).render(
      React.createElement(HowdyBoxSearch, context: context.componentContext)
    );

  if !LP.config.site_license_no_providers_available
    if LP.config.search_tabs_path
      searchTabsContainer = document.getElementById('js-search-tabs');
      ReactDOM.createRoot(searchTabsContainer).render(
        React.createElement(SearchTabs, context: context.componentContext)
      );

    selectedFacetsContainer = document.getElementById('js-selected-facets');
    ReactDOM.createRoot(selectedFacetsContainer).render(
      React.createElement(SelectedFacets, context: context.componentContext)
    );

    searchCountsContainer = document.getElementById('js-counts-result');
    ReactDOM.createRoot(searchCountsContainer).render(
      React.createElement(SearchCounts, context: context.componentContext, initialCount: LP.config.initial_counts)
    );

    searchSortContainer = document.getElementById('js-search-sort');
    ReactDOM.createRoot(searchSortContainer).render(
      React.createElement(SearchSort, context: context.componentContext, sortables: LP.config.search_sortables)
    );

  LP.module('CommonCoreInfo').closePopoversOnOutsideClick()
  LP.module('MobileHelpers').bindBackToTopButton()
  LP.module("Analytics").trackVirtualPageSuccess()

  LP.module('Share').init()

  posthog.capture(PH_EVENTS.SITE.VISITED_SEARCH_PAGE)

  if LpBoclips? && LpBoclips.LpBoclipsSearchPage? && $('#boclips-videos-section').length == 1
    videoState = context.getStore('VideoModeStore').currentState()
    new SearchResultsReposition() unless LP.isPhone()
    if videoState.valid
      @applyLoaderToResultCards()

    lpBoclipsContainer = document.getElementById('boclips-videos-section');
    ReactDOM.createRoot(lpBoclipsContainer).render(
      React.createElement(LpBoclips.LpBoclipsSearchPage, context: context.componentContext)
    );

Searches.minimalSearch = ->
  # Desktops. Chrome.
  window.onbeforeunload = (e) ->
    window.scrollTo(0, 0)

  if LP.config.withInfiniteScroll
    SearchInfiniteScroll.init()

  @initializeTooltip()

  @SearchContext.registerStore @RouteStore
  @SearchContext.registerStore Resources.ResourceStore
  context = new @SearchContext LP.config
  context.getStore('RouteStore').setSearchPath url: document.location.pathname, title: document.title

  new @SearchObservers context: context.componentContext
  Resources.ResourceModal.setContext context.componentContext

Searches.bindCollectionBuilderVimeoVideo = ->
  if $('#search-cb-banner')[0]
    $('#search-cb-banner-video-modal').on 'show.bs.modal', ->
      `import(/* webpackChunkName: 'vimeo-player' */ '@vimeo/player')`.then((module) ->
        Analytics.track 'played search banner video', { category: 'Videos' }
        new module.default('search-cb-video').play()
      )

    $('#search-cb-banner-video-modal').on 'hide.bs.modal', ->
      `import(/* webpackChunkName: 'vimeo-player' */ '@vimeo/player')`.then((module) ->
        new module.default('search-cb-video').pause()
      )

    $('#search-cb-banner').on 'click', ->
      `import(/* webpackChunkName: 'vimeo-player' */ '@vimeo/player')`.then((module) ->
        Analytics.track 'Clicked collections video', { category: 'Videos' }
        new module.default('search-cb-video', { id: $('#search-cb-video').data('vimeo-video-id') })
        $('#search-cb-banner-video-modal').modal('show')
      )

Searches.bindStopScrollOnDisabledPaginationButtons = ->
  $('#search-results .pagination .disabled').click (e) ->
    e.preventDefault();
    e.stopPropagation();

Searches.updateLayoutBasedOnCollectionBuilder = (collectionBuilderVisible) ->
  if collectionBuilderVisible
    $('.tiled-card, .thumbnail-card').removeClass('col-lg-4').addClass('col-lg-6')
    $('#js-search-heading').removeClass('col-lg-7 col-md-6')
  else
    $('.tiled-card, .thumbnail-card').addClass('col-lg-4').removeClass('col-lg-6')
    $('#js-search-heading').addClass('col-lg-7 col-md-6')

  LP.module('Searches').initializeTooltip()
